require('/opt/odin/app/frontend/components/new_menu/index.module.scss');module.exports = "../../app/cells/components/new_menu/show.erb";